import React from 'react'

import { Card, LineItem } from '@/components'
import { RentalApplication } from '@/types/RentalApplication'

import { vehicle1Data, vehicle2Data } from './MoveIn.data'

export function ParkingSection({ rentalApplication }: { rentalApplication: RentalApplication }) {
  return (
    <>
      {rentalApplication.needParking && (
        <>
          {rentalApplication.vehicleType && rentalApplication.vehicleType.length > 0 && (
            <Card cardClassName="mb-4" headerText="Vehicle 1" minimizable={true}>
              <div className="flex w-full flex-col px-4">
                {vehicle1Data.map(({ label, field, tag }, index) => {
                  return (
                    <LineItem
                      key={index}
                      label={label}
                      last={index === vehicle1Data.length - 1}
                      tag={tag}
                      value={rentalApplication[field]}
                    />
                  )
                })}
              </div>
            </Card>
          )}
          {rentalApplication.vehicle2Type && rentalApplication.vehicle2Type.length > 0 && (
            <Card cardClassName="mb-4" headerText="Vehicle 2" minimizable={true}>
              <div className="flex w-full flex-col px-4">
                {vehicle2Data.map(({ label, field, tag }, index) => {
                  return (
                    <LineItem
                      key={index}
                      label={label}
                      last={index === vehicle2Data.length - 1}
                      tag={tag}
                      value={rentalApplication[field]}
                    />
                  )
                })}
              </div>
            </Card>
          )}
        </>
      )}
    </>
  )
}
